<template>
	<div class="services" :class="{ 'onlyView': getPermissionAction }">
		<div class="services_block services_wrap">
			<dispatch
					v-if="services.dispatch.status"
					:valid="valid"
					:serviceList="services.dispatch"
					:dispatchersList="dispatchersList"
					:brokers="brokers"
					:dnu="dnu"
					:percent="percent"
					@updateDispatchData="onDispatchData"
					@updatePercent="onPercent"
					@updateDnuList="onDnuList"
			></dispatch>
			<safety
					v-if="services.safety.status"
					:valid="valid"
					:dispatchersList="dispatchersList"
					:serviceList="services.safety"
					:driversList="drivers"
					:safety_rate_driver="safety_rate_driver"
					:information="information"
					@updateSafetyRate="onSafetyRate"
					@updateSafetyData="onSafetyData"
					@updateItemEld="onItemEld"
			></safety>
			<billing
					v-if="services.billing.status"
					:factoringSwitcher="factoring"
					:factoring_id="factoring_id"
					:valid="valid"
					:serviceList="services.billing"
					:dispatchersList="dispatchersList"
					:billing_rate_driver="billing_rate_driver"
					@updateBillingRate="onBillingRate"
					@updateBillingData="onBillingData"
			></billing>
		</div>
		<div v-if="customersList" class="services_block">
			<services-item
				@updateOpenPopup="onOpenPopup"
				@updateServiceKey="onServiceKey"
        :editService="services['dispatch']"
				service-key="Dispatch"
			></services-item>
			<services-item
				@updateOpenPopup="onOpenPopup"
				@updateServiceKey="onServiceKey"
        :editService="services['safety']"
				service-key="Safety"
			></services-item>
			<services-item
				@updateOpenPopup="onOpenPopup"
				@updateServiceKey="onServiceKey"
        :editService="services['billing']"
				service-key="Billing"
			></services-item>
		</div>

<!--		<customer-popup-->
<!--				v-if="isDialog"-->
<!--				:isDialog="isDialog"-->
<!--				@updateClose="onClose"-->
<!--				:serviceKey="serviceKey"-->
<!--				:billing_history="billing_history"-->
<!--				:dispatcher_history="dispatcher_history"-->
<!--				:safety_history="safety_history"-->
<!--				@updateEditServices="onEditServices"-->
<!--		></customer-popup>-->

		<dialog-info-table
				v-if="isDialog"
				:flag="flag"
				:title="title"
				:text-no-info="textNoInfo"
				:headers="headers"
				:items="items"
				width="890px"
				@updateClose="onDialogInfoTableClose"
				@updateSave="onDialogInfoTableSave"
		></dialog-info-table>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import ServicesItem
from "@/components/Maintenance/ServicesItem/ServicesItem.vue";
import Dispatch
from "@/components/Maintenance/Customer/CustomerForm/SecondTab/Dispatch/Dispatch.vue";
import Billing from "@/components/Maintenance/Customer/CustomerForm/SecondTab/Billing/Billing.vue";
import Safety from "@/components/Maintenance/Customer/CustomerForm/SecondTab/Safety/Safety.vue";
// import CustomerPopup
// from "@/components/Maintenance/Customer/CustomerForm/CustomerPopup/CustomerPopup.vue";
import DialogInfoTable from "@/shared/DialogInfoTable/DialogInfoTable.vue";
import { driverHistorySafety } from "@/components/Accounting/CustomerInvoices/CustomerInvoicesCreate/defaultHeaders";

export default {
	name: "SecondTab",
	components: {
		DialogInfoTable,
		ServicesItem,
		Dispatch,
		Safety,
		Billing,
		// CustomerPopup
	},
	props: {
		valid: Object,
		services: Object,
		drivers: Array,
		requisites: Array,
		safety_rate_driver: [ Number, String ],
		information: String,
		billing_rate_driver: [ Number, String ],
		percent: [ Number, String ],
		billing_history: Array,
		dispatcher_history: Array,
		safety_history: Array,
		dnu: Array,
		factoring: Boolean,
		factoring_id: Number,
		getPermissionAction: Boolean
	},
	computed: mapGetters([ 'customersList' ]),
	data: () => ({
		dispatchersList: [],
		brokers: [],
		isDialog: false,
		serviceKey: '',
		textNoInfo: null,
		flag: null,
		title: null,
		headers: null,
		items: null,
	}),
	methods: {
		onItemEld(values) {
			this.$emit('updateItemEld', values);
		},
		onDnuList(value) {
			this.$emit('updateDnuList', value);
		},

		onOpenPopup(serviceKey) {
			// Safety
			// Salary
			this.serviceKey = serviceKey;
			this.isDialog = true;

			this.flag = `${ serviceKey }History`;
			this.title = `${ serviceKey } history`;
			this.textNoInfo = 'No historical data available at the moment.';

			if (serviceKey === 'Safety') {
				this.headers = driverHistorySafety;
				this.items = this.services.safety.history;
			}
			if (serviceKey === 'Salary' ) {
				this.headers = driverHistorySafety;
				this.items = this.services.salary.history;
			}
		},

		onClose() {
			this.isDialog = false;
		},
		onDispatchData({ creator, exceptionList, dispatchersNik }) {
			this.$emit('updateDispatch', { creator, exceptionList, dispatchersNik });
		},
		onSafetyData({ creator, drivers }) {
			this.$emit('updateSafety', { creator, drivers });
		},
		onBillingData({ creator, factoringList, requisitesList, billing_email, billing_phone, factoring, start_week }) {
			this.$emit('updateBilling', {
				creator,
				factoringList,
				requisitesList,
				billing_email,
				billing_phone,
				factoring,
				start_week
			});
		},
		onServiceKey({ value, date, serviceKey }) {
			this.$emit('updateServiceKey', { status: value, date, serviceKey });
		},
		onPercent(value) {
			this.$emit('updatePercent', value);
		},
		onSafetyRate(values) {
			this.$emit('updateSafetyRate', values);
		},
		onBillingRate(value) {
			this.$emit('updateBillingRate', value);
		},
		onEditServices(values) {
			this.$emit('updateEditServices', values);
		},

		onDialogInfoTableClose() {
			this.isDialog = false;
		},
		onDialogInfoTableSave() {
			this.isDialog = false;
		},
	},
	mounted() {
		const { dispatchers, brokers } = this.customersList;

		this.dispatchersList = dispatchers;
		this.brokers = brokers;
	}
};
</script>
<style scoped lang="scss">
@import "SecondTab";
</style>
